import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {GalleryButtonModel} from './model/gallery-button.model';

@Component({
  selector: 'app-gallery-controller',
  templateUrl: './gallery-controller.component.html',
  styleUrls: ['./gallery-controller.component.scss']
})
export class GalleryControllerComponent implements OnInit {

  @Input() controllers: GalleryButtonModel[] = [];

  @Input() theme: 'dark' | 'light' = 'light';

  @Input() selectFirst: boolean;

  @Output() changeSelect: EventEmitter<{ index: number; value: any }> = new EventEmitter<{ index: number, value: any }>();

  @Input() selected: GalleryButtonModel;

  color: string;

  ngOnInit() {
    this.color = this.theme === 'dark' ? '#fff' : '#2A2A2A';
    if (this.controllers.length && this.selectFirst) {
      this.selected = this.controllers[0];
    }
  }

  select(button: GalleryButtonModel, index: number) {
    this.selected = button;

    this.changeSelect.emit({
      index,
      value: button.value,
    });
  }

}
